export default __webpack_public_path__ + "static/media/Tunic of the Nebulous.020bb342.jpg";